var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"-18px -20px"}},[_c('iframe',{attrs:{"id":"map","src":_vm.mapUrl,"width":"100%","height":"calc(100vh - 60px)","frameborder":"0"}}),(_vm.errorMessage)?_c('div',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_c('coming-soon-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }